import coTerminationStyle from '../co-termination.module.css';

import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import ModalContainer from '../../../../../components/ModalContainer';
import Checkbox from '../../../../../components/Checkbox';
import Button from "../../../../../components/Button";

const RemainDateModal = props => {
  const { t } = useTranslation();
  const { 
    isOpenRemainDateModal,
    setOpenRemainDateModal, 
    toCoTerm 
  } = props;
  const data = { ...props.calculateDate };
  const defaultCheckboxesStatus = {
    'understand': false
  }
  const [ checkboxesStatus, setCheckboxesStatus ] = useState({...defaultCheckboxesStatus});

  const toggleCheckboxes = type => {
    const newCheckboxesStatus = {...checkboxesStatus};
    newCheckboxesStatus[type] = !newCheckboxesStatus[type];
    setCheckboxesStatus(newCheckboxesStatus);
  }

  return(
      <ModalContainer
        modalWidthType='modal-500px'
        openModal={isOpenRemainDateModal}
        closeModal={() => setOpenRemainDateModal(false)}
      >
        <div className='header'>
          <div className='title'>{t('6a2e51baa5')}</div>
        </div>
        <div className={`${coTerminationStyle['remain-date-modal-body']} body`}>
          <div className='mb-2'>{t('3ae3b1e72b')} {t('2f8d747f4e')}</div>
          <div className='mb-2'>{t('2e4f1b6173')}</div>
          <div className='mb-2'>{t('40c13f4fb5')}</div>
          <div className={coTerminationStyle['projected-date']}>
              <span>{t('b9a3a4ffda')} : </span>
              <span>{data.expirationData}</span>
          </div>
          <Checkbox
            id="understand"
            label={t('cdb61e1ca1')}
            checked={!!checkboxesStatus['understand']}
            onChange={() => toggleCheckboxes('understand')}
          />
        </div>
        <div className='footer'>
          <Button
            label={t('ea4788705e')}
            className='btn-cancel'
            onClick={() => setOpenRemainDateModal(false)}
          />
          <Button
            label={t('1b6436bc05')}
            className='btn-submit'
            disabled={!checkboxesStatus['understand']}
            onClick={() => toCoTerm()}
          />
        </div>
      </ModalContainer>
  )
}

export default React.memo(RemainDateModal);